import { collection, getDocs, addDoc, deleteDoc, doc, getDoc } from 'firebase/firestore';
import { firestore } from '_utils/firebase-app';

export const getQAPairs = async (airport) => {
  const collectionRef = collection(firestore, `support-desks/${airport}/qa`);
  const querySnapshot = await getDocs(collectionRef);
  const pairs = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  return pairs;
};

export const postQAPair = async (airport, question, answer) => {
  const collectionRef = collection(firestore, `support-desks/${airport}/qa`);
  const docRef = await addDoc(collectionRef, { question, answer });
  return docRef.id;
};

export const deleteQAPair = async (pairId, airport) => {
  const docRef = doc(firestore, `support-desks/${airport}/qa/${pairId}`);
  console.log('docRef:', docRef, 'data', (await getDoc(docRef)).data())
  await deleteDoc(docRef);
};

